// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
// import elementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import constant from '../static/js/Constant.js'
import baseJs from '../static/js/BaseJs.js'
import '../static/css/reset.css'
import '../static/css/Main.css'
import moment from 'moment'

Vue.config.productionTip = false
// Vue.use(elementUI)

Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
Vue.prototype.constant = constant
Vue.prototype.baseJs = baseJs
axios.defaults.withCredentials = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  axios
})



// WEBPACK FOOTER //
// ./src/main.js